import React from 'react';
import './Audience.css';

const Audience = () => {
  const audiences = [
    {
      icon: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="audience-svg">
          {/* Briefcase - Business Owners */}
          <defs>
            <linearGradient id="briefGrad1" x1="8" y1="16" x2="56" y2="56" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1b3a4b"/>
              <stop offset="1" stopColor="#3a7ca5"/>
            </linearGradient>
            <linearGradient id="briefGrad2" x1="20" y1="8" x2="44" y2="24" gradientUnits="userSpaceOnUse">
              <stop stopColor="#e84c3d"/>
              <stop offset="1" stopColor="#f7a072"/>
            </linearGradient>
          </defs>
          <rect x="6" y="22" width="52" height="34" rx="6" fill="url(#briefGrad1)" opacity="0.9"/>
          <rect x="8" y="24" width="48" height="10" rx="3" fill="#fff" opacity="0.15"/>
          <path d="M22 22V16a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v6" stroke="url(#briefGrad2)" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
          <rect x="27" y="34" width="10" height="8" rx="3" fill="#f7a072"/>
          <rect x="27" y="34" width="10" height="4" rx="2" fill="#e84c3d"/>
        </svg>
      ),
      title: 'Business Owners',
      description: 'Get real-time visibility across all branches. Make data-driven decisions with consolidated financial reports at your fingertips.'
    },
    {
      icon: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="audience-svg">
          {/* Bar Chart - Finance & Accounts */}
          <defs>
            <linearGradient id="barGrad1" x1="8" y1="56" x2="56" y2="8" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1b3a4b"/>
              <stop offset="1" stopColor="#3a7ca5"/>
            </linearGradient>
            <linearGradient id="barGrad2" x1="8" y1="56" x2="56" y2="8" gradientUnits="userSpaceOnUse">
              <stop stopColor="#e84c3d"/>
              <stop offset="1" stopColor="#f7a072"/>
            </linearGradient>
          </defs>
          <rect x="8" y="34" width="12" height="24" rx="3" fill="url(#barGrad1)" opacity="0.7"/>
          <rect x="26" y="20" width="12" height="38" rx="3" fill="url(#barGrad2)"/>
          <rect x="44" y="8" width="12" height="50" rx="3" fill="url(#barGrad1)"/>
          <rect x="8" y="34" width="12" height="6" rx="2" fill="#fff" opacity="0.25"/>
          <rect x="26" y="20" width="12" height="6" rx="2" fill="#fff" opacity="0.25"/>
          <rect x="44" y="8" width="12" height="6" rx="2" fill="#fff" opacity="0.25"/>
        </svg>
      ),
      title: 'Finance & Accounts Teams',
      description: 'Eliminate manual data collection. Automate reconciliation and reporting across multiple Tally instances.'
    },
    {
      icon: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="audience-svg">
          {/* Clipboard Check - Auditors */}
          <defs>
            <linearGradient id="clipGrad1" x1="12" y1="4" x2="52" y2="60" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1b3a4b"/>
              <stop offset="1" stopColor="#3a7ca5"/>
            </linearGradient>
            <linearGradient id="clipGrad2" x1="20" y1="30" x2="44" y2="50" gradientUnits="userSpaceOnUse">
              <stop stopColor="#27ae60"/>
              <stop offset="1" stopColor="#6dd5a0"/>
            </linearGradient>
          </defs>
          <rect x="12" y="10" width="40" height="50" rx="6" fill="url(#clipGrad1)" opacity="0.9"/>
          <rect x="14" y="12" width="36" height="8" rx="3" fill="#fff" opacity="0.12"/>
          <rect x="24" y="4" width="16" height="10" rx="5" fill="#e84c3d"/>
          <rect x="28" y="6" width="8" height="6" rx="3" fill="#f7a072"/>
          <path d="M24 36l6 6 12-14" stroke="url(#clipGrad2)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <rect x="18" y="50" width="28" height="3" rx="1.5" fill="#fff" opacity="0.15"/>
          <rect x="18" y="44" width="20" height="3" rx="1.5" fill="#fff" opacity="0.15"/>
        </svg>
      ),
      title: 'Auditors & CA Firms',
      description: 'Access client data securely and remotely. Perform audits faster with real-time synchronized data from multiple companies.'
    }
  ];

  return (
    <section className="audience">
      <div className="container">
        <h2 className="section-title">Who Is PreciseCA For?</h2>
        <div className="audience-grid">
          {audiences.map((item, i) => (
            <div key={i} className="audience-card">
              <div className="audience-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Audience;
